'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.compose = exports.shallowEqualsDebug = exports.shallowEquals = exports.addComputedProps = exports.default = undefined;

var _shallowEquals = require('./shallowEquals');

Object.defineProperty(exports, 'shallowEquals', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_shallowEquals).default;
  }
});
Object.defineProperty(exports, 'shallowEqualsDebug', {
  enumerable: true,
  get: function get() {
    return _shallowEquals.shallowEqualsDebug;
  }
});

var _addComputedProps2 = require('./addComputedProps');

var _addComputedProps3 = _interopRequireDefault(_addComputedProps2);

var _compose2 = require('./compose');

var _compose3 = _interopRequireDefault(_compose2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

exports.default = _addComputedProps3.default;
/**
 * The main library file. All top-level exports are listed here.
 */

exports.addComputedProps = _addComputedProps3.default;
exports.compose = _compose3.default;